export default __webpack_public_path__ + "static/media/convidando-usuarios.ec5ed6dc.png";